import React, { useState } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { Icon, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';

import ProgressBar from '../controls/ProgressBar';
import ErrorMessage from '../controls/ErrorMessage';
import { Portfolio } from '../../models/portfolio/portfolio';
import { portfolioService } from '../../services/portfolio.service';
import DialogPortfolioStart from '../controls/dialogs/DialogPortfolioStart';

const OverzichtActionMenu = ({ 
  params,
  onPortfolioUpdate: onPortfolioUpdate
}: { 
  params: GridRenderCellParams<Portfolio>;
  onPortfolioUpdate: () => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const [open, setOpenDialogs] = useState({
    portfolio: false,
  });

  // Handlers to open/close each dialog
  const openDialog = (dialog: keyof typeof open) => {
    // setSelectedId(id);
    setOpenDialogs((prev) => ({ ...prev, [dialog]: true }));
    handleCloseMenu();
  };

  const closeDialog = (dialog: keyof typeof open) => {
    setOpenDialogs((prev) => ({ ...prev, [dialog]: false }));
    setSelectedId(null);
  };
  
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, id: string) => {
    setSelectedId(id) // id: string
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSubmitPortfolio = (portfolio: Portfolio) => {
    if (selectedId === portfolio.id) {
      handlePortfolio(portfolio);
    }
    closeDialog('portfolio');
  };
  
  const handlePortfolio = async (portfolio: Portfolio) => {
    if (!portfolio) {
      console.error('Portfolio is null');
      return;
    }

    try {
      setLoading(true);
      const response = await portfolioService.updatePortfolio(portfolio);

      if (!response) {
        setLoading(false);
        // Handle error based on HTTP status code
        const errorMessage = await response.text();
        console.error('Failed to update portfolio:', errorMessage);
        throw new Error(errorMessage);
      }
    
      setLoading(false);
      onPortfolioUpdate();
    }
    catch (error) {
      setLoading(false);
      console.error('Error updating portfolio:', error);
      setError('Er is een fout opgetreden');
    }
  }

  return (
    <>
      <IconButton onClick={(e) => handleOpenMenu(e, params.id as string)}>
        <Tooltip title="Acties" placement="right" arrow>
          <Icon>more_vert</Icon>
        </Tooltip>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => openDialog('portfolio')}>
          <ListItemIcon>
            <Icon>edit</Icon>
          </ListItemIcon>
          Wijzigen
        </MenuItem>
      </Menu>

      <DialogPortfolioStart
        open={open.portfolio}
        portfolioId={params.row.id || undefined}
        onClose={ () => closeDialog('portfolio') }
        onSubmit={handleSubmitPortfolio} />

      { loading && (
        <ProgressBar />
      )}

      { error && (
        <ErrorMessage message={error} />
      )}
    </>
  );
};

export default OverzichtActionMenu;
